import{jsx as e}from"react/jsx-runtime";import s from"./styles/select.module.scss.js";function r(r){return e("div",{className:s.selectOptionsGroup,children:r.children})}export{r as default};
